import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import StandardWithRetailRate from './standard-with-retail-rate';
import StandardWithoutRetailRate from './standard-without-retail-rate';
import TransfersWithRetailRate from './transfers-with-retail-rate';
import TransfersWithoutRetailRate from './transfers-without-retail-rate';
import PriceBreakWithRetailRate from './price-break-with-retail-rate';
import PriceBreakWithoutRetailRate from './price-break-without-retail-rate';

const NonAccommodationRate = ({ rateSet, contractState, ...extraProps }) => {
  const RateTableTemplate = (() => {
    if (rateSet.nonStandardTemplateType === 'privateTransfer') {
      if (rateSet.rates.some(rate => rate.retailRate)) return TransfersWithRetailRate;
      return TransfersWithoutRetailRate;
    }
    if (rateSet.nonStandardTemplateType === 'priceBreak') {
      if (rateSet.rates.some(rate => rate.retailRate)) return PriceBreakWithRetailRate;
      return PriceBreakWithoutRetailRate;
    }
    if (rateSet.rates.some(rate => rate.retailRate)) return StandardWithRetailRate;
    return StandardWithoutRetailRate;
  })();
  return <RateTableTemplate {...rateSet} {...extraProps} contractState={contractState} standardNonAccom />;
};

NonAccommodationRate.propTypes = {
  rateSets: PropTypes.array,
};

export default connect(({ contracting }) => ({
  contractState: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractState']),
}))(NonAccommodationRate);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-tables/non-accom-rates-table/non-accommodation_rate_table.jsx